'use client'

import { createConsumer } from '@rails/actioncable'
import { useCallback, useEffect } from 'react'

import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import { useSession } from '@marketplace-web/shared/session'
import { useSystemConfiguration } from '@marketplace-web/shared/system-configuration'

const NOTIFICATION_CHANNEL = 'MsgThreadChannel'

type Props = {
  url: string
}

const ChatNotifications = ({ url }: Props) => {
  const { conversation, getConversationRequest } = useConversationContext()
  const session = useSession()
  const portal = useSystemConfiguration()?.portal
  const conversationId = conversation?.id
  const userId = session.user?.id

  const handleMessage = useCallback(() => {
    if (!conversationId || !userId) return

    if (!document.title.includes('*')) {
      document.title = ['*', document.title].join(' ')
    }

    getConversationRequest({ conversationId })
  }, [getConversationRequest, conversationId, userId])

  useEffect(() => {
    const cable = createConsumer(url)

    const channel = {
      channel: NOTIFICATION_CHANNEL,
      id: conversationId,
      country: portal,
      user_id: userId,
    }

    if (conversationId) {
      cable.subscriptions.create(channel, {
        received: handleMessage,
      })
    }

    return () => cable.disconnect()
  }, [url, conversationId, userId, portal, handleMessage])

  return null
}

export default ChatNotifications
